import { PHASE_TYPE_LABEL, type PhaseType } from './types';
import { groupOf } from './groups';

/**
 * Název fáze s barevnou tečkou její skupiny. Jedna komponenta pro celou aplikaci,
 * ať se stejná fáze všude pozná podle stejné barvy — v tabuli, ganttu, detailu
 * výroby i v reportech.
 */
export default function PhaseTypeTag({
  type,
  className = '',
  // Silnější varianta pro místa, kde fáze stojí sama za sebe (chipy u šablon).
  badge = false,
}: {
  type: PhaseType;
  className?: string;
  badge?: boolean;
}) {
  const g = groupOf(type);
  const label = PHASE_TYPE_LABEL[type];

  if (badge) {
    return (
      <span
        title={`${label} · ${g.label}`}
        className={`inline-flex items-center gap-1.5 rounded px-1.5 py-0.5 text-xs font-medium ${g.badge} ${className}`}
      >
        {label}
      </span>
    );
  }

  return (
    <span title={`${label} · ${g.label}`} className={`inline-flex min-w-0 items-center gap-1.5 ${className}`}>
      <span aria-hidden className={`h-1.5 w-1.5 shrink-0 rounded-full ${g.dot}`} />
      <span className="truncate">{label}</span>
    </span>
  );
}
